import { createSlice } from '@reduxjs/toolkit';
import { MW_5_14_0 } from '../../constants/migrationVersions';
import { runMigration } from '../../migrations';

export const AIR_AMBULANCE = 'airAmbulance';
export const OBLIQUE_IMAGERY = 'obliqueImagery';

const initialState = {
  [AIR_AMBULANCE]: { coordinates: null, isClickable: false },
  [OBLIQUE_IMAGERY]: { coordinates: null, isClickable: false },
};

const geoSelectionSlice = createSlice({
  name: 'geoSelection',
  initialState,
  reducers: {
    setCoordinates: (state, action) => {
      state[action.payload.key].coordinates = action.payload.coordinates;
      state[action.payload.key].isClickable = false;
    },
    setIsClickable: (state, action) => {
      state[action.payload.key].isClickable = action.payload.isClickable;
    },
    resetState: () => {
      return initialState;
    },
    extraReducers: builder => {
      builder.addCase('APP_INIT_START', state => {
        const migrationList = [MW_5_14_0];
        let newState = { ...state };
        migrationList.forEach(migration => {
          newState = runMigration(newState, 'geoSelection', migration);
        });
        return newState;
      });
    },
  },
});

export const {
  setCoordinates,
  setIsClickable,
  resetState,
} = geoSelectionSlice.actions;

export default geoSelectionSlice.reducer;
